<template>
  <Modal
    v-model="showModalNew"
    title="取消预约"
    :mask-closable="false"
    width="600"
    @on-cancel="$emit('closeOpinion')"
  >
    <div>
      <div class="box box-wrapper">
        <div class="box-title">取消原因</div>
        <Select v-model="reason" class="box_f1" @on-change="reasonSelect">
          <Option v-for="item in reasonList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div v-if="showInput" class=" box box-wrapper" style="padding-bottom: 50px">
        <div class="box-title"></div>
        <Input class="box_f1" type="textarea" v-model="reasonDetail" :rows="7" placeholder="请填写原因" />
      </div>
    </div>
    <div slot="footer" class="box" style="justify-content: flex-end">
      <Button type="text" @click="$emit('closeOpinion')">取消</Button>
      <Button type="primary" @click="confirmClick">确定</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: 'opinionModal',
    props:{
      showModal:{
        type:Boolean,
        default:false
      }
    },
    data () {
      return {
        reason:'',
        reasonList:[],
        reasonDetail:'',
        showModalNew:false,
        showInput:false,
      }
    },
    watch: {
      showModal () {
        this.showModalNew = JSON.parse(JSON.stringify(this.showModal))
      }
    },
    methods:{
      confirmClick () {
        if (!this.reasonDetail) {
          this.$Message.warning('请填写取消原因')
          return
        }
        this.$emit('confirmCancel',this.reasonDetail)
      },
      getSelect () {
        this.$get(this.urlobj.dictionaryList('appointment_cancel_msg')).then(res => {
          this.reasonList = res.rows.filter(item => item.dicType == 'appointment_cancel_msg8_manager')[0].children.map(item => {
            return {
              label:item.dicName,
              value:item.dicType,
              remark:item.remark
            }
          })
        })
      },
      reasonSelect (val) {
        if (val == 'appointment_cancel_msg8_manager_100') {
          this.reasonDetail = ''
          this.showInput = true
        }else {
          this.showInput = false
          this.reasonList.forEach(item => {
            if (item.value == val) {
              this.reasonDetail = item.label
            }
          })
        }

      }
    },
    mounted () {
      this.getSelect()
    }
  }
</script>

<style scoped>
  .box-wrapper{
    align-items: center;
    margin-bottom: 20px;
  }
.box-title{
  width: 75px;
  font-size: 15px;
}
</style>
